module.exports = __webpack_public_path__ + "static/img/loginbg.2f148c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/loginbg.jpg
// module id = 1110
// module chunks = 1